import script from "./SmartPhoneMiddle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartPhoneMiddle.vue?vue&type=script&setup=true&lang=ts"

import "./SmartPhoneMiddle.vue?vue&type=style&index=0&id=35463244&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35463244"]])

export default __exports__